import { IExpressionEvaluator } from "../../Models/IExpressionEvaluator";
import { IExpressionEvaluatorContext } from "../../Models/IExpressionEvaluatorContext";
import { VarRemoveExpression } from "../../Models/VarRemoveExpression";

export class VarRemoveExpressionEvaluator implements IExpressionEvaluator<VarRemoveExpression> {
  get type(): string {
    return "VarRemove";
  }

  evaluate(expression: VarRemoveExpression, context: IExpressionEvaluatorContext): any {
    context.Evaluator.assign(expression.Variable, context, undefined);
    return undefined;
  }
}
